<button
  *ngrxLet="isDisabled$ as disabled"
  mat-raised-button
  class="image !h-full"
  matTooltip="CliniView integration requires patient date of birth"
  [matTooltipDisabled]="!disabled"
  [disabled]="disabled"
  (click)="openPatient()"
>
  Launch CLINIVIEW
</button>
